<template>
  <x-page title="商品兑换" :loading="loading">
    <template v-if="!loading">
      <x-waterfall
        ref="waterfall"
        :key="waterfallKey"
        :class="_.waterfall"
        :load="handleLoad"
      >
        <template #default="{ data }">
          <div
            v-for="(item, index) in data"
            :key="index"
            :class="_.item"
            @click="goDetail(item)"
          >
            <div :class="_.top">
              <img :class="_.img" :src="item.commodityPic" />
              <div :class="_.text">
                <p :class="_.name">{{ item.commodityName }}</p>
                <p :class="_.packageContent">{{ item.packageContent }}</p>
                <p :class="_.opr">
                  <span>￥{{ item.commodityPrice }}</span>
                  <button :class="!item.commodityTotalStock && _.saleOut">
                    {{ item.commodityTotalStock ? '立即兑换' : '已售罄' }}
                  </button>
                </p>
              </div>
            </div>
            <div :class="_.bottom">兑换时间：{{ item.endTime }}之前可兑换</div>
          </div>
        </template>
      </x-waterfall>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { apiCommodityVirtualExchangeFindExchangeGoodsList } from '@/api'
  import { navigateTo } from '@/router'
  import { Track } from '@/utils/Track'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        page: '兑换商品页',
      })),
    ],
    data() {
      return {
        waterfallKey: 'exchange',
      }
    },

    computed: {
      loading() {
        return false
      },
    },

    methods: {
      async handleLoad({ pageNumber }) {
        return apiCommodityVirtualExchangeFindExchangeGoodsList({
          id: this.$route.query.id,
          pageIndex: pageNumber,
          pageSize: 10,
        }).then(res => {
          return res
        })
      },
      async goDetail(item) {
        if (item.commodityInfos.length > 1) {
          this.$router.push({
            name: 'ExchangeStore',
            query: {
              id: item.id,
              commodityPic: item.commodityPic,
              exchangeCommodityId: item.id,
              exchangeCommodityType: item.exchangeCommodityType,
              parentCommodityId: this.$route.query.id,
              orderNo: this.$route.query.orderNo,
            },
          })
        } else {
          switch (item.commodityInfos[0].exchangeCommodityType) {
            case 0:
              this.$router.push({
                name: 'GoodsIndex',
                query: {
                  id: item.commodityInfos[0].childCommodityId,
                  exchangeCommodityId: item.id,
                  type: 'exchange',
                  track_from: '兑换商品',
                  parentOrderNo: this.$route.query.orderNo,
                  parentCommodityId: this.$route.query.id,
                  skuId: item.commodityInfos[0].childSkuId,
                },
              })
              break
            case 1:
              this.$router.push({
                name: 'BookGoodsIndex',
                query: {
                  goodsId: item.commodityInfos[0].childCommodityId,
                  exchangeCommodityId: item.id,
                  type: 'exchange',
                  track_from: '兑换商品',
                  parentOrderNo: this.$route.query.orderNo,
                  parentCommodityId: this.$route.query.id,
                  skuId: item.commodityInfos[0].childSkuId,
                },
              })
              break
            case 4:
              this.$router.push({
                name: 'TravelGoodsIndex',
                query: {
                  goodsId: item.commodityInfos[0].childCommodityId,
                  exchangeCommodityId: item.id,
                  type: 'exchange',
                  track_from: '兑换商品',
                  parentOrderNo: this.$route.query.orderNo,
                  parentCommodityId: this.$route.query.id,
                  skuId: item.commodityInfos[0].childSkuId,
                },
              })
              break
            case 1001:
              if (!item.commodityTotalStock) {
                return
              }
              navigateTo('ExchangeInfo', {
                commodityId: item.commodityInfos[0].childCommodityId,
                exchangeCommodityId: item.id,
                parentOrderNo: this.$route.query.orderNo,
              })
              break
            default:
              break
          }
        }
      },
    },
  })
</script>

<style lang="scss" module>
  .waterfall {
    padding: 12px;
    .item {
      margin-bottom: 12px;
      background: #fff;
      padding: 12px;
      border-radius: 12px;
      .top {
        display: flex;
        .img {
          width: 90px;
          height: 90px;
          object-fit: cover;
          border-radius: 12px;
          margin-right: 10px;
        }
        .text {
          width: 100%;
          .name {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #222222;
            line-height: 18px;
            text-align: left;
            font-style: normal;
          }
          .packageContent {
            margin-top: 7px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 12px;
            text-align: left;
            font-style: normal;
          }
          .opr {
            margin-top: 18px;
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            span {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 16px;
              color: #ff111c;
              line-height: 22px;
              text-align: left;
              font-style: normal;
            }
            button {
              background: #ff202a;
              border-radius: 15px;
              width: 81px;
              height: 30px;
              text-align: center;
              border: none;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #ffffff;
              line-height: 30px;
              text-align: center;
              font-style: normal;

              &.saleOut {
                background: #f5f5f5;
                color: #999999;
              }
            }
          }
        }
      }
      .bottom {
        margin-top: 12px;
        padding: 6px 0;
        padding-left: 12px;
        background: #f7f7f7;
        border-radius: 4px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 17px;
        font-style: normal;
      }
    }
  }
</style>
